module.exports = __webpack_public_path__ + "img/白云山.3cbaf9c8.png";